import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useCompanyWithGroupData() {
    const { data: companiesWithGroupOptions } = useQuery({
        queryKey: ['companies-with-group'],
        queryFn: async () => {
            const { data } = await axios.get(route('v2.companies.with-group.get'));
            return data;
        },
        placeholderData: [],
    });

    return {
        companiesWithGroupOptions,
    };
}
